import React from "react";
import { DHook } from "../../libs/common_hooks/DHook";
import { dcolors, yahooFin } from "corexxx";
import { DResponsiveWindow } from "../../libs/dweb/DResponsiveWindow";
import { DPageHeader } from "../../libs/dweb/DPageHeader";
import { DLoadingUI } from "../../libs/dweb/DLoadingUI";
import { DStockGrowthTable } from "../../libs/dweb/DStockGrowthTable";
import { DText } from "../../libs/dweb/DText";
import { DRow } from "../../libs/dweb/DRow";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import { DSelectInput } from "../../libs/dweb/DSelectInput";

export function GrowthAnalysis() {
  // Group data by year and month
  const groupedData: Record<number, Record<number, number[]>> = {};
  const [stockname, setStockname] = React.useState<string>("");
  let appComamnd = useDAppCommand();

  let stockHook = DHook.useNetwork(
    `/api/utils/preload_data?name=MonthlyStockData`,
    { isSimpleStoreEndpoint: true },
  );

  Object.keys;

  stockHook.state.data?.["^SPX"].forEach((item: any) => {
    const date = new Date(item.timestamp * 1000);
    const year = date.getFullYear();
    const month = date.getMonth();

    if (!groupedData[year]) {
      groupedData[year] = {};
    }
    if (!groupedData[year][month]) {
      groupedData[year][month] = [];
    }
    groupedData[year][month].push(item.pchange);
  });

  // Calculate sum of percentage changes for each year and month
  const years = Object.keys(groupedData)
    .map(Number)
    .sort((a, b) => a - b);
  if (stockHook.state.data == null) {
    return <DLoadingUI />;
  }
  return (
    <DResponsiveWindow style={{ overflowX: "auto" }}>
      <DPageHeader
        title={"Stock Analysis For last 10 years"}
        rightView={
          <DSelectInput
            style={{ width: 200 }}
            label="Stock Name"
            value={stockname}
            options={Object.keys(stockHook.state.data)?.map((x) => ({
              key: x,
              value: x,
              text: x,
            }))}
            onChange={setStockname}
          />
        }
      />
      <DStockGrowthTable data={stockHook.state.data?.[stockname] || []} />
    </DResponsiveWindow>
  );
}
